<section [ngStyle]="{ height: height }" class="scroll bgw">
  <ng-content> </ng-content>
</section>
